<template lang="pug">
ValidationObserver(v-slot="{invalid}")
  .panel
    .panel-block
      .container.is-fluid
        .field.is-horizontal
          .field-label.is-normal
            .label Universal Date &amp; Time
          .field-body
            .field.has-addons
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.gregorianDateDDMMYYYY.name" v-bind:rules="ui.gregorianDateDDMMYYYY.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.gregorianDateDDMMYYYY.mask" v-bind:placeholder="ui.gregorianDateDDMMYYYY.placeholder" v-model="ui.gregorianDateDDMMYYYY.model")
                  .help.is-danger(v-for="error in errors") {{error}}
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.gregorianDateHHMMSS.name" v-bind:rules="ui.gregorianDateHHMMSS.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.gregorianDateHHMMSS.mask" v-bind:placeholder="ui.gregorianDateHHMMSS.placeholder" v-model="ui.gregorianDateHHMMSS.model")
                  .help.is-danger(v-for="error in errors") {{error}}
        .field.is-horizontal
          .field-label.is-normal
            .label Estimated Position
          .field-body
            .field.has-addons
              .control
                ValidationProvider(v-bind:name="ui.estimatedPositionNS.name" v-bind:rules="ui.estimatedPositionNS.rules" v-slot="{errors}")
                  .select(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" )
                    select(v-model="ui.estimatedPositionNS.model")
                      option(v-for="option of ui.estimatedPositionNS.options" v-bind:value="option") {{ option }}
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.estimatedPositionDDMMD.name" v-bind:rules="ui.estimatedPositionDDMMD.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.estimatedPositionDDMMD.mask" v-bind:placeholder="ui.estimatedPositionDDMMD.placeholder" v-model="ui.estimatedPositionDDMMD.model")
                  .help.is-danger(v-for="error in errors") {{error}}
              .control
                ValidationProvider(v-bind:name="ui.estimatedPositionEW.name" v-bind:rules="ui.estimatedPositionEW.rules" v-slot="{errors}")
                  .select(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" )
                    select(v-model="ui.estimatedPositionEW.model")
                      option(v-for="option of ui.estimatedPositionEW.options" v-bind:value="option") {{ option }}
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.estimatedPositionDDDMMD.name" v-bind:rules="ui.estimatedPositionDDDMMD.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.estimatedPositionDDDMMD.mask" v-bind:placeholder="ui.estimatedPositionDDDMMD.placeholder" v-model="ui.estimatedPositionDDDMMD.model")
                  .help.is-danger(v-for="error in errors") {{error}}
        .field.is-horizontal
          .field-label.is-normal
            .label Body
          .field-body
            .field
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.body.name" v-bind:rules="ui.body.rules" v-slot="{errors}")
                  .select.is-fullwidth(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" )
                    select(v-model="ui.body.model")
                      option(v-for="option of ui.body.options" v-bind:value="option") {{ option }}
    .panel-block
      .container.is-fluid
        .field.is-horizontal
          .field-label.is-normal
            .label Declination &amp; GHA
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.bodyDecNS.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.bodyDecDDMMD.model")
              .control
                input.input.addon(disabled)
              .control.is-expanded
                input.input(disabled v-bind:value="ui.bodyGhaDDDMMD.model")
        .field.is-horizontal
          .field-label.is-normal
            .label Chosen Position
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.chosenPositionNS.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.chosenPositionDDMMD.model")
              .control
                input.input.addon(disabled v-bind:value="ui.chosenPositionEW.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.chosenPositionDDDMMD.model")
        .field.is-horizontal
          .field-label.is-normal
            .label LHA
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled)
              .control.is-expanded
                input.input(disabled)
              .control
                input.input.addon(disabled)
              .control.is-expanded
                input.input(disabled v-bind:value="ui.bodyLhaDDDMMD.model")
        .field.is-horizontal
          .field-label.is-normal
            .label Calculated Altitude
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.bodyCalculatedAltitudePM.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.bodyCalculatedAltitudeDDMMD.model")
    .panel-block
      .container.is-fluid
        .field.is-horizontal
          .field-label.is-normal
            .label Sextant Altitude
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.sextantAltitudePM.model")
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.sextantAltitudeDDMMD.name" v-bind:rules="ui.sextantAltitudeDDMMD.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.sextantAltitudeDDMMD.mask" v-bind:placeholder="ui.sextantAltitudeDDMMD.placeholder" v-model="ui.sextantAltitudeDDMMD.model")
                  .help.is-danger(v-for="error in errors") {{error}}
        .field.is-horizontal
          .field-label.is-normal
            .label Index Error
          .field-body
            .field.has-addons
              .control
                ValidationProvider(v-bind:name="ui.indexErrorPM.name" v-bind:rules="ui.indexErrorPM.rules" v-slot="{errors}")
                  .select(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" )
                    select(v-model="ui.indexErrorPM.model")
                      option(v-for="option of ui.indexErrorPM.options" v-bind:value="option") {{ option }}
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.indexErrorDDMMD.name" v-bind:rules="ui.indexErrorDDMMD.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.indexErrorDDMMD.mask" v-bind:placeholder="ui.indexErrorDDMMD.placeholder" v-model="ui.indexErrorDDMMD.model")
                  .help.is-danger(v-for="error in errors") {{error}}
        .field.is-horizontal
          .field-label.is-normal
            .label Height of Eye &amp; Dip
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.heightOfEyePM.model")
              .control.is-expanded
                ValidationProvider(v-bind:name="ui.heightOfEyeDM.name" v-bind:rules="ui.heightOfEyeDM.rules" v-slot="{errors}")
                  standard-input(v-bind:class="[errors.length ? 'is-danger' : 'is-primary']" v-bind:mask="ui.heightOfEyeDM.mask" v-bind:placeholder="ui.heightOfEyeDM.placeholder" v-model="ui.heightOfEyeDM.model")
                  .help.is-danger(v-for="error in errors") {{error}}
              .control
                input.input.addon(disabled v-bind:value="ui.dipPM.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.dipDDMMD.model")
        .field.is-horizontal
          .field-label.is-normal
            .label Apparent Altitude
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.apparentAltitudePM.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.apparentAltitudeDDMMD.model")
        //- .field.is-horizontal
        //-   .field-label.is-normal
        //-     .label Body Parallax
        //-   .field-body
        //-     .field.has-addons
        //-       .control
        //-         input.input.addon(disabled v-bind:value="ui.bodyParallaxPM.model")
        //-       .control.is-expanded
        //-         input.input(disabled v-bind:value="ui.bodyParallaxDDMMD.model")
        //- .field.is-horizontal
        //-   .field-label.is-normal
        //-     .label Body Refraction
        //-   .field-body
        //-     .field.has-addons
        //-       .control
        //-         input.input.addon(disabled v-bind:value="ui.bodyRefractionPM.model")
        //-       .control.is-expanded
        //-         input.input(disabled v-bind:value="ui.bodyRefractionDDMMD.model")
        //- .field.is-horizontal
        //-   .field-label.is-normal
        //-     .label Body Semi-diameter
        //-   .field-body
        //-     .field.has-addons
        //-       .control
        //-         input.input.addon(disabled v-bind:value="ui.bodySemidiameterPM.model")
        //-       .control.is-expanded
        //-         input.input(disabled v-bind:value="ui.bodySemidiameterDDMMD.model")
        .field.is-horizontal
          .field-label.is-normal
            .label Altitude Correction
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.altitudeCorrectionPM.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.altitudeCorrectionDDMMD.model")
        .field.is-horizontal
          .field-label.is-normal
            .label Observed Altitude
          .field-body
            .field.has-addons
              .control
                input.input.addon(disabled v-bind:value="ui.observedAltitudePM.model")
              .control.is-expanded
                input.input(disabled v-bind:value="ui.observedAltitudeDDMMD.model")
    .panel-block
      .container.is-fluid
        .field.is-horizontal
          .field-label.is-normal
            .label Solution
          .field-body
            .field
              .control.is-expanded
                input.input(disabled v-bind:value="solution")
</template>

<script>
import moment from 'moment'

import StandardInput from '@/components/StandardInput.vue'

import AstroMixin, { MASK_DDDMMD, MASK_DDMMD, MASK_DDMMYYYY, MASK_DM, MASK_HHMMSS, PLACEHOLDER_DDDMMD, PLACEHOLDER_DDMMD, PLACEHOLDER_DDMMYYYY, PLACEHOLDER_DM, PLACEHOLDER_HHMMSS } from '@/mixins/AstroMixin.vue'

export default {
  components: {
    StandardInput
  },
  mixins: [
    AstroMixin
  ],
  data () {
    return {
      ui: {
        altitudeCorrectionDDMMD: {
          model: ''
        },
        altitudeCorrectionPM: {
          model: ''
        },
        apparentAltitudeDDMMD: {
          model: ''
        },
        apparentAltitudePM: {
          model: ''
        },
        body: {
          model: '',
          options: ['Sun LL'],
          rules: 'VALIDATE_REQUIRED|VALIDATE_BODY'
        },
        bodyAzimuthDDD: {
          model: ''
        },
        bodyCalculatedAltitudeDDMMD: {
          model: ''
        },
        bodyCalculatedAltitudePM: {
          model: ''
        },
        bodyDecDDMMD: {
          model: ''
        },
        bodyDecNS: {
          model: ''
        },
        bodyGhaDDDMMD: {
          model: ''
        },
        bodyLhaDDDMMD: {
          model: ''
        },
        bodyParallaxDDMMD: {
          model: ''
        },
        bodyParallaxPM: {
          model: ''
        },
        bodyRefractionDDMMD: {
          model: ''
        },
        bodyRefractionPM: {
          model: ''
        },
        bodySemidiameterDDMMD: {
          model: ''
        },
        bodySemidiameterPM: {
          model: ''
        },
        chosenPositionDDDMMD: {
          model: ''
        },
        chosenPositionDDMMD: {
          model: ''
        },
        chosenPositionEW: {
          model: ''
        },
        chosenPositionNS: {
          model: ''
        },
        dipDDMMD: {
          model: ''
        },
        dipPM: {
          model: ''
        },
        estimatedPositionDDDMMD: {
          mask: MASK_DDDMMD,
          model: '',
          name: 'Longitude',
          placeholder: PLACEHOLDER_DDDMMD,
          rules: 'VALIDATE_REQUIRED|VALIDATE_DDDMMD'
        },
        estimatedPositionDDMMD: {
          mask: MASK_DDMMD,
          model: '',
          name: 'Latitude',
          placeholder: PLACEHOLDER_DDMMD,
          rules: 'VALIDATE_REQUIRED|VALIDATE_DDMMD'
        },
        estimatedPositionEW: {
          model: '',
          options: ['E', 'W'],
          rules: 'VALIDATE_REQUIRED|VALIDATE_EW'
        },
        estimatedPositionNS: {
          model: '',
          options: ['N', 'S'],
          rules: 'VALIDATE_REQUIRED|VALIDATE_NS'
        },
        gregorianDateDDMMYYYY: {
          mask: MASK_DDMMYYYY,
          model: '',
          name: 'Date',
          placeholder: PLACEHOLDER_DDMMYYYY,
          rules: 'VALIDATE_REQUIRED|VALIDATE_DDMMYYYY'
        },
        gregorianDateHHMMSS: {
          mask: MASK_HHMMSS,
          model: '',
          name: 'Time',
          placeholder: PLACEHOLDER_HHMMSS,
          rules: 'VALIDATE_REQUIRED|VALIDATE_HHMMSS'
        },
        heightOfEyeDM: {
          mask: MASK_DM,
          model: '',
          name: 'Height of Eye',
          placeholder: PLACEHOLDER_DM,
          rules: 'VALIDATE_REQUIRED|VALIDATE_DM'
        },
        heightOfEyePM: {
          model: ''
        },
        indexErrorDDMMD: {
          mask: MASK_DDMMD,
          model: '',
          name: 'Index Error',
          placeholder: PLACEHOLDER_DDMMD,
          rules: 'VALIDATE_REQUIRED|VALIDATE_DDMMD'
        },
        indexErrorPM: {
          model: '',
          options: ['+', '-'],
          rules: 'VALIDATE_REQUIRED|VALIDATE_PM'
        },
        interceptNM: {
          model: ''
        },
        interceptTA: {
          model: ''
        },
        observedAltitudeDDMMD: {
          model: ''
        },
        observedAltitudePM: {
          model: ''
        },
        sextantAltitudeDDMMD: {
          mask: MASK_DDMMD,
          model: '',
          name: 'Hs',
          placeholder: PLACEHOLDER_DDMMD,
          rules: 'VALIDATE_REQUIRED|VALIDATE_DDMMD'
        },
        sextantAltitudePM: {
          model: ''
        }
      }
    }
  },
  computed: {
    solution () {
      return `${this.ui.interceptNM.model} ${this.ui.interceptTA.model} ${this.ui.bodyAzimuthDDD.model}`
    }
  },
  mounted () {
    this.$watch(() => [
      this.ui.body.model,
      this.ui.estimatedPositionDDDMMD.model,
      this.ui.estimatedPositionDDMMD.model,
      this.ui.estimatedPositionEW.model,
      this.ui.estimatedPositionNS.model,
      this.ui.gregorianDateDDMMYYYY.model,
      this.ui.gregorianDateHHMMSS.model
    ], this.solveSextantAltitude)
    //
    this.$watch(() => [
      this.ui.body.model,
      this.ui.estimatedPositionDDDMMD.model,
      this.ui.estimatedPositionDDMMD.model,
      this.ui.estimatedPositionEW.model,
      this.ui.estimatedPositionNS.model,
      this.ui.heightOfEyeDM.model,
      this.ui.sextantAltitudeDDMMD.model,
      this.ui.indexErrorDDMMD.model,
      this.ui.indexErrorPM.model,
      this.ui.gregorianDateDDMMYYYY.model,
      this.ui.gregorianDateHHMMSS.model
    ], this.solveIntercept)
    //
    const defaultDate = moment.utc()
    const defaultFloatHe = 0
    const defaultRadiansEpLatitude = 0
    const defaultRadiansEpLongitude = 0
    const defaultRadiansHs = 0
    //
    this.ui.body.model = this.ui.body.options[0]
    this.ui.estimatedPositionDDDMMD.model = this.convertFromRadiansToDDDMMDAndEW(defaultRadiansEpLongitude).stringDDDMMD
    this.ui.estimatedPositionDDMMD.model = this.convertFromRadiansToDDMMDAndNS(defaultRadiansEpLatitude).stringDDMMD
    this.ui.estimatedPositionEW.model = this.convertFromRadiansToDDDMMDAndEW(defaultRadiansEpLongitude).stringEW
    this.ui.estimatedPositionNS.model = this.convertFromRadiansToDDMMDAndNS(defaultRadiansEpLatitude).stringNS
    this.ui.gregorianDateDDMMYYYY.model = this.convertFromDateToDDMMYYYYAndHHMMSS(defaultDate).stringDDMMYYYY
    this.ui.gregorianDateHHMMSS.model = this.convertFromDateToDDMMYYYYAndHHMMSS(defaultDate).stringHHMMSS
    this.ui.heightOfEyeDM.model = this.convertFromFloatToDMAndPM(defaultFloatHe).stringDM
    this.ui.heightOfEyePM.model = this.convertFromFloatToDMAndPM(defaultFloatHe).stringPM
    this.ui.indexErrorDDMMD.model = this.convertFromRadiansToDDMMDAndPM(defaultRadiansHs).stringDDMMD
    this.ui.indexErrorPM.model = this.convertFromRadiansToDDMMDAndPM(defaultRadiansHs).stringPM
    this.ui.sextantAltitudeDDMMD.model = this.convertFromRadiansToDDMMD(defaultRadiansHs).stringDDMMD
    this.ui.sextantAltitudePM.model = this.convertFromRadiansToDDMMDAndPM(defaultRadiansHs).stringPM
  },
  methods: {
    solveIntercept () {
      this.estimatedPositionLatitude = this.convertFromDDMMDAndNSToRadians(this.ui.estimatedPositionDDMMD.model, this.ui.estimatedPositionNS.model).radians
      this.estimatedPositionLongitude = this.convertFromDDDMMDAndNSToRadians(this.ui.estimatedPositionDDDMMD.model, this.ui.estimatedPositionEW.model).radians
      this.gregorianDate = this.convertFromDDMMYYYYAndHHMMSSToDate(this.ui.gregorianDateDDMMYYYY.model, this.ui.gregorianDateHHMMSS.model).date
      this.heightOfEye = this.convertFromDMAndPMToFloat(this.ui.heightOfEyeDM.model, this.ui.heightOfEyePM.model).float
      this.indexError = this.convertFromDDMMDAndPMToRadians(this.ui.indexErrorDDMMD.model, this.ui.indexErrorPM.model).radians
      this.sextantAltitude = this.convertFromDDMMDAndPMToRadians(this.ui.sextantAltitudeDDMMD.model, this.ui.sextantAltitudePM.model).radians
      //
      this.ui.altitudeCorrectionDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.altitudeCorrection).stringDDMMD
      this.ui.altitudeCorrectionPM.model = this.convertFromRadiansToDDMMDAndPM(this.altitudeCorrection).stringPM
      this.ui.apparentAltitudeDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.apparentAltitude).stringDDMMD
      this.ui.apparentAltitudePM.model = this.convertFromRadiansToDDMMDAndPM(this.apparentAltitude).stringPM
      this.ui.bodyAzimuthDDD.model = this.convertFromRadiansToDDD(this.bodyAzimuth).stringDDD
      this.ui.bodyCalculatedAltitudeDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.bodyCalculatedAltitude).stringDDMMD
      this.ui.bodyCalculatedAltitudePM.model = this.convertFromRadiansToDDMMDAndPM(this.bodyCalculatedAltitude).stringPM
      this.ui.bodyDecDDMMD.model = this.convertFromRadiansToDDMMDAndNS(this.bodyDec).stringDDMMD
      this.ui.bodyDecNS.model = this.convertFromRadiansToDDMMDAndNS(this.bodyDec).stringNS
      this.ui.bodyGhaDDDMMD.model = this.convertFromRadiansToDDDMMD(this.bodyGha).stringDDDMMD
      this.ui.bodyLhaDDDMMD.model = this.convertFromRadiansToDDDMMD(this.bodyLha).stringDDDMMD
      this.ui.bodyParallaxDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.bodyParallax).stringDDMMD
      this.ui.bodyParallaxPM.model = this.convertFromRadiansToDDMMDAndPM(this.bodyParallax).stringPM
      this.ui.bodyRefractionDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.bodyRefraction).stringDDMMD
      this.ui.bodyRefractionPM.model = this.convertFromRadiansToDDMMDAndPM(this.bodyRefraction).stringPM
      this.ui.bodySemidiameterDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.bodySemidiameter).stringDDMMD
      this.ui.bodySemidiameterPM.model = this.convertFromRadiansToDDMMDAndPM(this.bodySemidiameter).stringPM
      this.ui.chosenPositionDDDMMD.model = this.convertFromRadiansToDDDMMDAndEW(this.chosenPositionLongitude).stringDDDMMD
      this.ui.chosenPositionDDMMD.model = this.convertFromRadiansToDDMMDAndNS(this.chosenPositionLatitude).stringDDMMD
      this.ui.chosenPositionEW.model = this.convertFromRadiansToDDDMMDAndEW(this.chosenPositionLongitude).stringEW
      this.ui.chosenPositionNS.model = this.convertFromRadiansToDDMMDAndNS(this.chosenPositionLatitude).stringNS
      this.ui.dipDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.dip).stringDDMMD
      this.ui.dipPM.model = this.convertFromRadiansToDDMMDAndPM(this.dip).stringPM
      this.ui.interceptNM.model = this.convertFromRadiansToNMAndTA(this.intercept).stringNM
      this.ui.interceptTA.model = this.convertFromRadiansToNMAndTA(this.intercept).stringTA
      this.ui.observedAltitudeDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.observedAltitude).stringDDMMD
      this.ui.observedAltitudePM.model = this.convertFromRadiansToDDMMDAndPM(this.observedAltitude).stringPM
    },
    solveSextantAltitude () {
      this.estimatedPositionLatitude = this.convertFromDDMMDAndNSToRadians(this.ui.estimatedPositionDDMMD.model, this.ui.estimatedPositionNS.model).radians
      this.estimatedPositionLongitude = this.convertFromDDDMMDAndNSToRadians(this.ui.estimatedPositionDDDMMD.model, this.ui.estimatedPositionEW.model).radians
      this.gregorianDate = this.convertFromDDMMYYYYAndHHMMSSToDate(this.ui.gregorianDateDDMMYYYY.model, this.ui.gregorianDateHHMMSS.model).date
      //
      this.ui.sextantAltitudeDDMMD.model = this.convertFromRadiansToDDMMDAndPM(this.bodyCalculatedAltitude).stringDDMMD
      this.ui.sextantAltitudePM.model = this.convertFromRadiansToDDMMDAndPM(this.bodyCalculatedAltitude).stringPM
    }
  }
}
</script>
